export default "__VITE_ASSET__9440e11e__"